// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"254":"fbc37b178ed24a9c9304","740":"e78096426ad6465d8a01"}[chunkId] + ".css";
};